import { render, staticRenderFns } from "./OAuth.vue?vue&type=template&id=66db18ba&"
import script from "./OAuth.vue?vue&type=script&lang=js&"
export * from "./OAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports